module.exports = __webpack_public_path__ + "img/banner-10.224a7f8b.jpg";